<template>
  <div class="exchange">
    <div class="exchange__date">{{ $res.Views.Layout_CurrencyRateForPayment }} {{$formatDateShortDDMM(model.date)}}:</div>
    <div class="exchange__rates">
      <span class="exchange__values">
        <span v-for="rate in model.rates" :key="rate.source">
          <strong >{{rate.source}}</strong>={{$formatPrice(rate.rate)}}
        </span> 
        <a class="exchange__archive" :href="model.exchangeRateArchiveUrl" target="_blank" v-tippy="$tippyOptions($res.Views.Layout_CurrencyRatesArchive)">
          <svg-icon icon="lh-coins"></svg-icon>
        </a>
      </span>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/common/controls/SvgIconControl.vue";

export default {
  components: {
    SvgIcon,
  },
  props: {
    model: Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>


.exchange {
  line-height: 20px;
  white-space: nowrap;
}

.exchange__date {
  color: var(--second-20);
  font-size: 11px;
  line-height: 16px;
}

.exchange__rates {
  margin-top: 5px;
}

.exchange__values {
  position: relative;
  font-weight: 600;
  display: flex;
  gap: 8px;

  strong {
    font-weight: 700;
  }
}

.exchange__archive {
  background: transparent;
  border: none;
  outline: none;
  width: 20px;
  height: 20px;
  color: var(--main-10);
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: var(--main-40);
  }
}
</style>
